/**
 * Agents activation Mixpanel funnel (beginning of path). Identity is the acting
 * userId; `_organization` is attached for org-level filtering/breakdown.
 *
 * Create Organization → Agents Usecase Selected → Agent Created
 */
export const AGENTS_ORG_FUNNEL_EVENTS = {
    USECASE_SELECTED: 'Agents Usecase Selected - [Agents]',
    AGENT_CREATED: 'Agent Created - [Agents]',
};
export const AGENT_ANALYTICS_SOURCES = ['cli', 'dashboard_onboarding', 'dashboard', 'api'];
export const AGENTS_USECASE_SOURCES = ['usecase_picker', 'product_type_deeplink', 'cli'];
/** Request header used by dashboard/CLI to attribute Agent Created funnel source. */
export const NOVU_ANALYTICS_SOURCE_HEADER = 'Novu-Analytics-Source';
export function isAgentAnalyticsSource(value) {
    return typeof value === 'string' && AGENT_ANALYTICS_SOURCES.includes(value);
}
//# sourceMappingURL=agents-org-funnel.js.map